'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse from "./presto.types$proto$-Generic-Response.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$GenericResponse$() {
}
export { $c_Lpresto_types$proto$GenericResponse$ as $c_Lpresto_types$proto$GenericResponse$ };
$p = $c_Lpresto_types$proto$GenericResponse$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$GenericResponse$;
/** @constructor */
function $h_Lpresto_types$proto$GenericResponse$() {
}
export { $h_Lpresto_types$proto$GenericResponse$ as $h_Lpresto_types$proto$GenericResponse$ };
$h_Lpresto_types$proto$GenericResponse$.prototype = $p;
$p.l = (function() {
  return "GenericResponse";
});
$p.cGL = (function(x$0) {
  return new $j_presto$002etypes$0024proto$0024$002dGeneric$002dResponse.$c_Lpresto_types$proto$GenericResponse(x$0.j(0));
});
var $d_Lpresto_types$proto$GenericResponse$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$GenericResponse$, "presto.types$proto$GenericResponse$", ({
  a3c: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$proto$GenericResponse$ as $d_Lpresto_types$proto$GenericResponse$ };
var $n_Lpresto_types$proto$GenericResponse$;
function $m_Lpresto_types$proto$GenericResponse$() {
  if ((!$n_Lpresto_types$proto$GenericResponse$)) {
    $n_Lpresto_types$proto$GenericResponse$ = new $c_Lpresto_types$proto$GenericResponse$();
  }
  return $n_Lpresto_types$proto$GenericResponse$;
}
export { $m_Lpresto_types$proto$GenericResponse$ as $m_Lpresto_types$proto$GenericResponse$ };
//# sourceMappingURL=presto.types$proto$-Generic-Response$.js.map
